import type { AnchorHTMLAttributes, ReactNode } from "react";
import { Link as RouterLink } from "@tanstack/react-router";
import { parseHref } from "@/lib/navigation";

// next/link's shape over TanStack Router: `href` is a plain string, internal
// links become client navigations (with the route module and page data
// preloaded on hover), anything with a scheme is a normal anchor.

type Props = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  href: string;
  replace?: boolean;
  /** Accepted for parity with next/link; the router keeps scroll on same-route search changes. */
  scroll?: boolean;
  children?: ReactNode;
};

export default function Link({ href, replace, scroll: _scroll, children, ...rest }: Props) {
  if (/^[a-z][a-z0-9+.-]*:/i.test(href)) {
    return (
      <a href={href} {...rest}>
        {children}
      </a>
    );
  }
  const { to, search, hash } = parseHref(href);
  return (
    <RouterLink to={to as never} search={search as never} hash={hash} replace={replace} resetScroll={_scroll !== false} {...rest}>
      {children}
    </RouterLink>
  );
}
